import { Component, OnInit } from '@angular/core';
import { DatePipe } from '@angular/common';
import { RailtracReportsService } from '../../railtrac-reports.service';
import { PageService } from '@bds/core';
import { ReportConstants } from '../../models/report-parameters.model';

@Component({
    selector: 'lib-transit-time-trip-cycle-detail',
    templateUrl: './transit-time-trip-cycle-detail.component.html',
    styleUrl: './transit-time-trip-cycle-detail.component.css',
})
export class TransitTimeTripCycleDetailComponent implements OnInit {
    public gridId = 128;
    public gridSource: any;
    public displayReport: boolean = false;
    public controlNames: string[] = ['Begin Date', 'End Date'];
    displayedColumns: string[] = [];
    public totalCount: number = 0;

    constructor(public reportService: RailtracReportsService, public pageService: PageService) {}

    ngOnInit(): void {
        this.pageService.setHeader('Transit Time Trip Cycle Detail Report');

        (this as any).customizeColumns = (columns: any[]) => {
            const datePipe = new DatePipe('en-US');
            const shipCol = columns.find((c: any) => c.dataField === 'ship_date_time');
            if (shipCol) {
                shipCol.dataType = 'date';
                shipCol.calculateDisplayValue = (rowData: any) => {
                    const value = rowData['ship_date_time'];
                    return value ? datePipe.transform(value, 'MM/dd/yyyy', 'UTC') : '';
                };
            }
            ['prev_trip_close_date_time', 'trip_cls_date_time'].forEach((field) => {
                const col = columns.find((c: any) => c.dataField === field);
                if (col) {
                    col.dataType = 'datetime';
                    col.calculateDisplayValue = (rowData: any) => {
                        const value = rowData[field];
                        return value ? datePipe.transform(value, 'MM/dd/yyyy HH:mm', 'UTC') : '';
                    };
                }
            });
        };
    }

    onGetReportClick(event: any) {
        this.displayReport = true;
        this.gridSource = this.reportService.CreateAspNetDatastore(
            ReportConstants.ReportDataApiCall,
            this.gridId.toString(),
            event.startDate,
            event.endDate,
        );
    }

    onCancelClick() {
        this.displayReport = false;
    }

    onContentReady(e: any) {
        if (e.component) {
            const dataSource = e.component.getDataSource();
            if (dataSource) {
                this.totalCount = dataSource.totalCount() || 0;
            }
        }
    }
}
